export default __webpack_public_path__ + "static/media/dark_iron_sword.8dce5b63.png";